import { useNavigate } from '@reach/router'
import React from 'react'
import SheetWrapper from '../../components/SheetWrapper'
import { HOME_PATH } from '../../constants'
import { useLocalizedContent } from '../../hooks/useLocalizedContent'
import { useAppDispatch } from '../../store/hooks'
import { toggleCreateSuccess } from '../../store/slices/sheetsSlice'
import CreateSuccessContent from './CreateSuccessContent'
import { useCreateGroupMutation } from '../../services/createGroupApi'

const CreateSuccess = ({ isOpen }: { isOpen: boolean }) => {
  const { getContent } = useLocalizedContent()
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [_, { data: lastCreatedGroup }] = useCreateGroupMutation({
    fixedCacheKey: 'create-pool',
  })

  const goToHomePage = () => {
    dispatch(toggleCreateSuccess())
    navigate(`${HOME_PATH}/${lastCreatedGroup.id}`)
  }

  return (
    <SheetWrapper
      title={getContent('create.success.title')}
      isOpen={isOpen}
      onCloseComplete={goToHomePage}
    >
      <CreateSuccessContent
        shareLink={lastCreatedGroup?.shareLink}
        groupId={lastCreatedGroup?.id}
      />
    </SheetWrapper>
  )
}

export default CreateSuccess
